import { render, staticRenderFns } from "./playMode.vue?vue&type=template&id=370d0faf&scoped=true&"
import script from "./playMode.vue?vue&type=script&lang=js&"
export * from "./playMode.vue?vue&type=script&lang=js&"
import style0 from "./playMode.vue?vue&type=style&index=0&id=370d0faf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d0faf",
  null
  
)

export default component.exports